import classNames from 'classnames';
import type { AnchorHTMLAttributes } from 'react';
import React from 'react';
import type { ButtonComponentProps } from './Button';
import { useButtonClassNames } from './Button';

export interface LinkButtonProps
  extends Omit<ButtonComponentProps, 'selected' | 'caret' | 'target' | 'rel'>,
    AnchorHTMLAttributes<HTMLAnchorElement> {
  linkTo: string;
  newWindow?: boolean;
}

const LinkButton: React.FC<LinkButtonProps> = props => {
  const { className } = useButtonClassNames(props);
  const { disabled, onClick, linkTo, newWindow, destructive, children, ...rest } = props;

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      // Links don't have a "disabled" property, so we preventDefault when clicked
      // so it mimicks the behavior of actual buttons.
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  const wrappedChildren = typeof children === 'string' ? <span>{children}</span> : children;

  return (
    <a
      {...rest}
      href={linkTo}
      data-act-as-button
      className={classNames(className, props.className)}
      onClick={handleClick}
      target={newWindow ? '_blank' : undefined}
      rel={newWindow ? 'noopener' : undefined}
    >
      {wrappedChildren}
    </a>
  );
};
LinkButton.displayName = 'LinkButton';
export default LinkButton;

// // Relative URL's use react-router's Link component
// return (
//   <NavLink
//     {...rest}
//     to={linkTo}
//     activeClassName={
//       activeClassName === true ? styles.isActive : activeClassName || undefined
//     }
//     style={style}
//     className={buttonClass}
//     onClick={handleClick}
//   >
//     {content}
//   </NavLink>
// );
